import ExcelJS from 'exceljs'
import { useToast } from '@/lib/hooks/use-toast'
import { formatCurrency } from '../utils'
import { saveAs } from 'file-saver'



 export async function handleDownloadExcel (creditControls: any[], cnpj: string) {

  const { toast } = useToast()

    if (!creditControls || creditControls.length === 0) {
      toast({ variant: 'destructive', description: 'Não há dados para exportar.' })
      return
    }

    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet('Créditos')

    worksheet.addRow([`Controle de Compensação - CNPJ: ${cnpj}`])
    worksheet.addRow([])

    worksheet.addRow([
      'Competência',
      'Crédito Utilizado (R$)',
      'Selic (R$)',
      'Total Compensado (R$)',
      'Honorários (R$)',
      'Status Pago'
    ])

    creditControls.forEach(control => {
      worksheet.addRow([
        `${control.mesCompetencia}/${control.anoCompetencia}`,
        formatCurrency(control.creditOrigin),
        formatCurrency(control.creditUtilizado),
        formatCurrency(control.selic),
        formatCurrency(control.compensacao),
        formatCurrency(control.comissao),
        control.isPago
      ])
    })

    worksheet.columns = [{ width: 15 }, { width: 22 }, { width: 18 }, { width: 20 }, { width: 18 }, { width: 15 }]

    const buffer = await workbook.xlsx.writeBuffer()
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    saveAs(blob, `detalhes_credito_${cnpj}.xlsx`)
  }
